import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export default makeStyles((theme: Theme) =>
  createStyles({
    cart: {
      minWidth: '600px !important',
      [theme.breakpoints.down('sm')]: {
        minWidth: '100% !important',
      }
    },
    bold: {
      fontWeight: '700 !important',
    },
    gray: {
      color: '#6D6A6F !important'
    },
    header: {
      display: 'flex',
      gap: '.5rem',
      padding: '0 .5rem !important',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      }
    },
    promoCodeButton: {
      color: '#2F7BF7 !important',
      textTransform: 'inherit',
      fontWeight: '700 !important',
      height: 'fit-content !important',
      lineHeight: '1.5 !important',
      fontSize: '16px !important',
      padding: '0 !important'
    },
    itemSubtitle: {
      fontSize: '12px !important',
      color: '#6D6A6F !important',
      marginRight: '1rem !important'
    },
    successPromoCodeContainer: {
      width: 'fit-content !important'
    },
    showPromoCode: {
      color: "#2F7BF7 !important",
      fontSize: "16px !important",
      fontFamily: "LatoBlack !important",
      fontWeight: '900 !important',
      lineHeight: "24px !important",
      wordWrap: "break-word",
      cursor: "pointer",
    },
    promoSuccessIcon: {
      fill: '#17B975 !important',
      marginRight: '.5rem !important',
      width: '1rem !important'
    },
    promoSuccessText: {
      color: '#0E905A !important',
      fontWeight: '700 !important'
    },
    row: {

    },
    title: {
      fontSize: '20px !important',
      fontFamily: 'NextArtHeavy !important'
    },
    subtitle: {
      color: '#6D6A6F !important'
    },
    savedForLater: {
      color: '#2F7BF7 !important'
    },
    dontForgetTitle: {
      color: '#01AA59 !important',
      display: 'flex',
      alignItems: 'center',
      gap: '.5rem',
      '@global': {
        '.MuiSvgIcon-root': {
          fill: '#FFC531 !important'
        }
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '18px !important'
      }
    },
    submitButton: {
      height: '54px !important',
      padding: '0 1rem !important',
      color: 'var(--white-color) !important',
      // backgroundColor: 'var(--repairs-yellow-500)',
      backgroundColor: '#01AA59 !important',
      borderColor: '#01AA59 !important',
      borderRadius: '8px !important',
      textTransform: 'inherit',
      margin: '5px !important',
      maxWidth: 'fit-content !important',
      '&:hover': {
        backgroundColor: 'var(--bosscat-green-700) !important',
      },
      '&.Mui-disabled': {
        opacity: .6,
        color: 'white !important'
      },
      '@global': {
        '.MuiTypography-root': {
          fontWeight: '900 !important',
        }
      },
      endIcon: {
        width: '5px !important',
        height: '5px !important'
      },
      [theme.breakpoints.down('sm')]: {
        width: '100% !important',
        minWidth: '100% !important',
        margin: 0
        // height: '40px'
      }
    },
    promoCode: {
      padding: '.2rem !important',
      marginTop: '.5rem !important',
    },
    footer: {
      display: 'flex',
      height: 'fit-content',
      padding: '.5rem',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      background: 'white',
      [theme.breakpoints.down('sm')]: {
        padding: '.5rem',
        paddingLeft: 4,
        // height: '200px',
        bottom: 'env(safe-area-inset-bottom)',
        // position: 'fixed',
        flexDirection: 'column',
        width: '100%',
        zIndex: 9999,
        marginBottom: '5rem'
      }
    },
    footerContent: {
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    /*     relativeContainer: {
          minHeight: '70vh',
          [theme.breakpoints.down('sm')]: {
            minHeight: 'inherit',
            height: '70vh',
            position: 'static',
            // minHeight: 'fit-content'
          }
        }, */

    relativeContainer: {
      minHeight: '70vh',
      [theme.breakpoints.down('sm')]: {
        minHeight: '100%',
      }
    },
    showPriceDetail: {
      [theme.breakpoints.down('sm')]: {
        height: '60vh',
      }
    },
    priceDetailContainer: {
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        // marginBottom: '4rem',
        // position: 'fixed',
        bottom: '0',
        width: '100%',
        height: 'fit-content'
      }
    },
    absoluteContainer: {
      /*  display: 'flex',
       justifyContent: 'space-between',
       flexDirection: 'column', */
      [theme.breakpoints.down('sm')]: {
        // minHeight: '55vh',
        position: 'static',
        // marginBottom: '3rem'
      }
    },
    buttonAdd: {
      minWidth: '86px !important',
      height: '48px !important',
      textTransform: 'none',
      color: '#01AA59 !important',
      fontWeight: '700 !important',
      backgroundColor: '#E6F7EE !important',
      borderRadius: 8,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '40px !important'
      },
      margin: '5px',
      '&:hover': {
        backgroundColor: '#E6F7EE !important',
      }
    },
    spinner: {
      display: 'flex',
      justifyContent: 'center',
      margin: '3rem'
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '.5rem'
    },
    itemsContainer: {
      gap: '.5rem',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '.5rem',
      [theme.breakpoints.down('sm')]: {
        padding: '0 !important'
      }
    },
    cartItem: {
      // gridTemplateColumns: '1fr 0.2fr !important', 
      gridColumnGap: '0',
      [theme.breakpoints.down('sm')]: {
        gap: '.5rem',
        gridTemplateAreas: "'itemTitle price' 'quantity .'",
      }
    },
    buttonRemove: {
      textTransform: 'none',
      fontWeight: 900,
      borderRadius: 8,
      backgroundColor: 'white !important',
      color: '#0B060F',
      boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 0px 1px rgba(26, 42, 85, 0.31)',
      minWidth: 86,
      height: 48,
      '&:hover': {
        backgroundColor: 'var(--bosscat-blue-700)'
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    buttonSaveForLater: {
      textTransform: 'none',
      fontWeight: 900,
      borderRadius: 8,
      backgroundColor: 'white !important',
      color: '#2F7BF7',
      boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 0px 1px rgba(26, 42, 85, 0.31)',
      minWidth: 86,
      height: 48,
      '&:hover': {
        backgroundColor: 'var(--bosscat-blue-700)'
      }
    },
    buttons: {
      flexDirection: 'row-reverse'
    },
    spinnerContainer: {
      display: 'flex',
      justifyContent: 'center'
    },
    buttonContactUs: {
      color: '#2F7BF7',
      textDecoration: 'underline',
      fontWeight: '700 !important' as unknown as number,
      cursor: 'pointer'
    },
  })
)
